var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDatapicker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M24.73 26.52V12.75H7.27v13.77zm0-20.04q1.02 0 1.77.75c.75.75.75 1.09.75 1.77v17.52q0 1.02-.75 1.74c-.75.72-1.09.72-1.77.72H7.27q-1.05 0-1.785-.72a2.35 2.35 0 0 1-.735-1.74V9q0-1.02.735-1.77c.735-.75 1.085-.75 1.785-.75H8.5V4.02h2.52v2.46h9.96V4.02h2.52v2.46zm-2.46 8.79v2.46h-2.52v-2.46zm-5.04 0v2.46h-2.46v-2.46zm-4.98 0v2.46H9.73v-2.46z"
})));
export default SvgDatapicker;